import API from './api'
import Http from './http'
import Post from './post'
import Get from './get'
import ResultCode from './result-code'

export {
  Http,
  API,
  Post,
  Get,
  ResultCode
}



// WEBPACK FOOTER //
// ./src/libs/request/index.js